import { mapFieldArrToObjSchema } from '../../validation/useValidation';
import * as R from 'ramda';
export const categoryModel = {
    id: 350,
    name: "تسنیم فی التفسیر القرآن، الجزء 21",
    slug: "تسنیم-فی-التفسیر-القرآن-الجزء-21",
    description: null,
    price: 1570000,
    discounted_price: 1334500,
    discounted_percent: 15,
    product_type: {},
    category: [],
    images: [],
    tags: [],
    attributes: []
};

export const singleCategoryInit = {
    id: 'id',
    title: '',
    rial_price: 0,
    rial_discount_price: 0,
    cent_price: 0,
    cent_discount_price: 0,
    language: 'fa',
    lessons_file_type: '',
    refund_days: '',
    description: null,
    summery: null,
    max_allowed_incomplete_exercises: null,
    media_id: null,
    banner_id: null,
    banner_mobile_id: null,
    category_id: null,
    total_lessons: null,
    sessions_with_teacher: null,
    base_release_at: null,
    created_at: '2021-02-09T18:31:10.000000Z',
    updated_at: '2021-02-09T18:31:10.000000Z',
    deleted_at: null,
    slug: ''
};

export const remUnusedPropCategory = R.omit([
    'slug',
    'id',
]);

export const pickerPropCategory = R.pick([
    'name',
    'description',
    'price',
    'discounted_price',
    'discounted_percent',
    'product_type',
    'category',
    'images',
    'tags',
    'attributes'
    //
]);
export const pickerPropCategoryPatch = R.pick([
    'title',
    'rial_price',
    'rial_discount_price',
    'cent_price',
    'cent_discount_price',
    'language',
    'lessons_file_type',
    'total_lessons',
    'sessions_with_teacher',
    'refund_days',
    'description',
    'base_release_at',
    'base_release_gap',
    'max_allowed_incomplete_exercises',
    'summery',
    'slug',
    //
]);

export const FormAgencyInit = {
    name: "",
    province: {},
    address:"",
    postal_code:"",
    tel:"",
    lat:null,
    long:null
};

const agencyValidationsArr = [
    ['name', 'string'],
    ['province', 'object'],
    ['address', 'string'],
    ['postal_code', 'string'],
];


export const agencyValidations = mapFieldArrToObjSchema(agencyValidationsArr);
